import * as React from "react"

export default function FacebookIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1316_30804)">
        <g clipPath="url(#clip1_1316_30804)">
          <path
            d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.093 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.563V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z"
            fill={props.fill}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1316_30804">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
        <clipPath id="clip1_1316_30804">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
